import { useState } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const menuItems = ["Home", "About","Services", "Testimony", "Photos"];

  return (
    <nav className="w-full fixed top-0 left-0 z-50 bg-[#1A1F2B]/95 backdrop-blur-lg shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">

        {/* Logo + Title */}
        <Link to="/" className="flex items-center gap-3 group">
          <div
            className="w-11 h-11 rounded-full bg-cover bg-center ring-2 ring-[#D9A05B] shadow-md"
            style={{ backgroundImage: "url('/Images/church.jpg')" }}
          ></div>
          <h1 className="text-white font-semibold text-xl tracking-wide group-hover:text-[#D9A05B] transition-all">
            Moriah Church
          </h1>
        </Link>

        {/* Desktop Menu */}
        <ul className="hidden md:flex items-center gap-10 text-white font-medium">
          {menuItems.map((item) => (
            <li key={item}>
              <Link
                to={item === "Home" ? "/" : `/${item.toLowerCase()}`}
                className="hover:text-[#D9A05B] transition-colors duration-200"
              >
                {item}
              </Link>
            </li>
          ))}
        </ul>

        {/* Mobile Menu Icon */}
        <button
          className="md:hidden text-white text-3xl"
          onClick={() => setOpen(!open)}
        >
          {open ? <FiX /> : <FiMenu />}
        </button>
      </div>

      {/* Mobile Dropdown */}
      <div
        className={`md:hidden bg-[#1A1F2B] transition-all duration-300 overflow-hidden ${
          open ? "max-h-96 py-4" : "max-h-0"
        }`}
      >
        <ul className="flex flex-col items-center text-white space-y-6 font-medium">
          {menuItems.map((item) => (
            <li key={item}>
              <Link
                to={item === "Home" ? "/" : `/${item.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="hover:text-[#D9A05B] transition-colors duration-200"
              >
                {item}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
